// extracted by mini-css-extract-plugin
export var avatarContainer = "_fn-0";
export var avatarTypingWave = "_fn-i";
export var gray = "_fn-f";
export var green = "_fn-c";
export var icon = "_fn-9";
export var image = "_fn-1";
export var lg = "_fn-6";
export var md = "_fn-5";
export var presenceDot = "_fn-b";
export var red = "_fn-d";
export var sm = "_fn-4";
export var status = "_fn-a";
export var typingDot = "_fn-h";
export var typingPill = "_fn-g";
export var xl = "_fn-7";
export var xs = "_fn-3";
export var xxl = "_fn-8";
export var xxs = "_fn-2";
export var yellow = "_fn-e";